import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { packageForMyBookingFunc } from '../../AdminPackageDetails/PackageShowcase/commonFunction';

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    marginBottom: 8,
    // paddingHorizontal: 20,
  },
  packageName: {
    fontSize: 8,
    color: '#374151',
    marginBottom: 4,
  },
  billTo: {
    fontSize: 10,
    // color: '#374151',
    fontWeight: 'bold',
  },
});

const BillTo = ({ invoice }) => {
  const items3 = JSON.parse(invoice);
  const packageDetails = packageForMyBookingFunc(items3?.child);

  return (
    <View style={styles.container}>
      {packageDetails.is_package && (
        <Text style={styles.packageName}>Package Name: {packageDetails.package_name}</Text>
      )}
      <Text style={styles.billTo}>Booking Details</Text>
    </View>
  );
};

export default BillTo;
